import css from './legal.css';

export const getLegalNotesTabs = ({ selectedPage }) => [
    {
        text: 'Impressum',
        selected: selectedPage === 'ImpressumPage',
        linkProps: {
            activeClassName: css.linkActive,
            name: 'ImpressumPage',
        },
    },
    {
        text: 'Datenschutz',
        selected: selectedPage === 'PrivacyPolicyPage',
        linkProps: {
            activeClassName: css.linkActive,
            name: 'PrivacyPolicyPage',
        },
    },
    {
        text: 'AGB',
        selected: selectedPage === 'TermsOfServicePage',
        linkProps: {
            activeClassName: css.linkActive,
            name: 'TermsOfServicePage',
        },
    },
    {
        text: 'Richtlinien',
        selected: selectedPage === 'GuidlinePage',
        linkProps: {
            activeClassName: css.linkActive,
            name: 'GuidlinePage',
        },
    },
    // {
    //     text: 'Inserate',
    //     selected: selectedPage === 'GuidlinePage',
    //     linkProps: {
    //         activeClassName: css.linkActive,
    //         name: 'GuidlinePage',
    //     },
    // },
];
